import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { voidBill } from '../api/parking-billing.ts';

export default function useVoidBilling(): UseMutationResult<
  string,
  Error,
  string
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => voidBill(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['unconfirmedBillings'] });
      queryClient.invalidateQueries({ queryKey: ['confirmedBillings'] });
    },
  });
}
